export default "__VITE_ASSET__CAOayplr__"